<template>
  <div>
    <v-icon
      v-for="star of stars" :key="star"
      :class="{ active: note >= star }">
      star_rate
    </v-icon>
  </div>
</template>

<script>
  export default {
    props: {
      note: {
        type: Number,
        required: true
      },
      stars: {
        type: Array,
        default: () => [20, 40, 60, 80, 100]
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '../variables'

  i {
    width: 1em;
    display: inline-block;
    color: $grey.base;

    &.active {
      color: $yellow.darken-2
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Stars.vue